import styled from "styled-components";
import Button from "../../widgets/Button";

const StyledButton = styled(Button)``;

export default StyledButton;
